export default __webpack_public_path__ + "static/media/hundered-finance-logo.49750f79.png";